import DatePicker from 'react-datepicker'
import dayjs from 'dayjs'
import React, { memo } from 'react'

export const InputField = memo(
  ({ item, screenAction, changeRegistrationProperty }) => {
    const isReadOnly = screenAction === 'xem'

    switch (item.type) {
      case 'select':
        return (
          <select
            className="form-control input-dot"
            value={item.value ?? ''}
            disabled={isReadOnly}
            onChange={(e) =>
              changeRegistrationProperty(item.fieldName, e.target.value)
            }
          >
            <option value={item.defaultValue?.value}>
              {item.defaultValue?.label}
            </option>
            {item.options?.map((opt, i) => (
              <option key={i} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        )

      case 'date':
        return (
          <DatePicker
            dateFormat="dd/MM/yyyy"
            customInput={
              <input
                type="text"
                className="form-control input-dot input-date"
              />
            }
            onChangeRaw={(e) => {
              const newDate = dayjs(
                e?.target?.value?.trim(),
                'DD/MM/YYYY',
                true,
              )
              if (newDate.isValid()) {
                changeRegistrationProperty(
                  item.fieldName,
                  dayjs(newDate).format('YYYY-MM-DD HH:mm:ss'),
                )
              }
            }}
            // showIcon={true}
            todayButton={<button>Hôm nay</button>}
            readOnly={isReadOnly}
            selected={item.value ? new Date(item.value) : ''}
            onChange={(value) => {
              changeRegistrationProperty(item.fieldName, value)
            }}
          />
        )
      case 'radio':
        return (
          <div
            className="radio-group"
            style={{ display: 'flex', alignItems: 'center', gap: '15px' }}
          >
            {item.options?.map((opt, i) => (
              <span key={i} className="radio-label">
                <input
                  type="radio"
                  name={item.fieldName}
                  value={opt.value}
                  id={i}
                  checked={item.value == opt.value}
                  disabled={isReadOnly}
                  onChange={(e) =>
                    changeRegistrationProperty(item.fieldName, e.target.value)
                  }
                />
                <label
                  for={i}
                  style={{
                    cursor: 'pointer',
                    marginLeft: '5px',
                    marginBottom: 0,
                  }}
                >
                  {opt.label}
                </label>
              </span>
            ))}
          </div>
        )

      default:
        return (
          <input
            type={item.type || 'text'}
            className="form-control input-dot"
            value={item.value ?? ''}
            readOnly={isReadOnly}
            onBlur={(e) =>
              changeRegistrationProperty(item.fieldName, e.target.value?.trim())
            }
            onChange={(e) =>
              changeRegistrationProperty(item.fieldName, e.target.value)
            }
          />
        )
    }
  },
)
